export enum SectionType {
    TEXT = 'text',
    LIST = 'list',
    COLLAPSIBLE = 'collapsible',
    COLLAPSIBLE_LIST = 'collapsible_list',
}